import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from 'src/app/core/user.service';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
  standalone: false
})
export class EditProfileComponent {
  
  @Input() user?: User;
  @Output() finished: EventEmitter<any> = new EventEmitter<any>();

  form!: FormGroup;
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    if (!this.form) {
      this.setForm();
    }
  }

  ngOnChanges() {
    if (!this.form) {
      this.setForm();
    }
    if (this.user) {
      this.form.setValue({name: this.user?.firstName, email: this.user?.email});
    }
  }

  setForm() {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(1)]],
      email: ['', [Validators.required, Validators.email]],
    });
  }

  updateProfile() {
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      return;
    }
    this.user!.firstName = this.form.value['name'];
    this.isLoading = true;
    this.userService.updateProfile(this.user!).subscribe((result) => {
      this.isLoading = false;
      this.finished.emit();
    });
  }

  getControl(control: string) {
    return this.form!.get(control) as FormControl;
  }
}
